<template>
    <div class="offer-calendar" :class="calendarClass" v-if="!isMobile">
        <div
            v-for="date in specialDates"
            :key="date.value"
            class="ocalendar-item"
            @click="selectDate(date.value)"
            :class="{'active': isSpecialDateSelected(date.value) }"
        >
            <div class="ocalendar-spacer"></div>
            <p class="ocalendar-item-text">{{
                $t(
                    date.text,
                    {
                        value: date.translatorValue,
                    }
                )
            }}</p>
        </div>
        <div
            class="ocalendar-item"
            v-for="date in dates"
            @click="selectDate(date.date)"
            :class="{'active': isDateSelected(date.date)}"
            :key="date.date"
        >
            <div class="ocalendar-spacer"></div>
            <p class="ocalendar-item-text">{{date.formated}}</p>
            <p class="ocalendar-item-text" v-if="!date.isToday">{{$t('DAY_' + date.abbrv.toUpperCase())}}</p>
        </div>
        <div class="ocalendar-item"
            @click="selectDate('all')"
            :class="{'active': isSpecialDateSelected('all')}"
        >
            <div class="ocalendar-spacer"></div>
            <p class="ocalendar-item-text">{{$t('ALLOFFER')}}</p>
        </div>
    </div>
    <div class="offer-menu-calendar-container" :class="calendarClass" v-else-if="isMobile">
        <div class="offer-menu">
            <div class="offer-menu-item" v-if="showBackButton" @click="toggleGamesMenu">
                <div class="sportsicon-back"></div>
                <div class="gamesm-text">{{ $t('GOBACK') }}</div>
            </div>
            <div
                v-for="date in specialDates"
                :key="date.value"
                class="offer-menu-item"
                @click="selectDate(date.value)"
                :class="{'active': isSpecialDateSelected(date.value) }"
            >
                <p>{{
                    $t(
                        date.text,
                        {
                            value: date.translatorValue,
                        }
                    )
                }}</p>
            </div>
            <div
                class="offer-menu-item"
                v-for="date in dates"
                @click="selectDate(date.date)"
                :class="{'active': isDateSelected(date.date)}"
                :key="date.date"
            >
                <p>{{date.formated}}</p>
                <p v-if="!date.isToday">{{$t('DAY_' + date.abbrv.toUpperCase())}}</p>
            </div>
            <div
                class="offer-menu-item"
                @click="selectDate('all')"
                :class="{'active': isSpecialDateSelected('all')}"
            >
                {{$t('ALLOFFER')}}
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters,
}
from 'vuex';

import moment from 'moment-timezone';

export default
{
    name: 'OfferCalendar',
    props: {
        showBackButton: {
            type: Boolean,
            default: false,
        },
        offerLoading: {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            specialDatesValues: [3, 6, 12],
        };
    },
    methods:
    {
        ...mapActions(
            {
                selectDateInit: 'selectDate',
            },
        ),
        toggleGamesMenu()
        {
            this.$emit('togglegamesmenu');
        },
        selectDate(date)
        {
            if (this.offerLoading)
            {
                return;
            }

            this.$router.push({
                params:
                {
                    startDate: date,
                    mode: undefined, // jumps from favourites
                },
            });
        },
        isSpecialDateSelected(currentSpecial)
        {
            return currentSpecial === this.specialDate
            || (currentSpecial === 'all' && this.onFavourites);
        },
        isDateSelected(date)
        {
            if (this.onFavourites)
            {
                return false;
            }
            if (this.specialDate !== false || this.startDate === undefined || this.startDate === null)
            {
                return false;
            }

            const startDate = moment.tz(this.startDate, this.globals.publicConfig.localeSetup.timezone);

            if (moment(date).format('YYYY-MM-DD') === startDate.format('YYYY-MM-DD'))
            {
                return true;
            }
            return false;
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'startDate',
            'globals',
            'specialDate',
        ]),
        calendarClass()
        {
            return {
                'disabled-overlay': this.offerLoading,
            };
        },
        onFavourites()
        {
            return this.$route.params.mode === 'favourites';
        },
        dates()
        {
            const dates = [];
            const now = moment();

            for (let i = 0; i < 7; i += 1)
            {
                const date = moment(now).add(i, 'd');

                if (i !== 0)
                {
                    date.set(
                        {
                            hours: 0,
                            minutes: 0,
                            seconds: 0,
                        },
                    );
                }

                dates.push(
                    {
                        formated: (i === 0)
                            ? this.$t('TODAY')
                            : moment(date, this.globals.publicConfig.localeSetup.timezone).format('DD.MM.'),
                        date: date.format('YYYY-MM-DD'),
                        abbrv: moment(date, this.globals.publicConfig.localeSetup.timezone).format('ddd'),
                        isToday: (i === 0),
                    },
                );
            }

            return dates;
        },
        specialDates()
        {
            const datesOut = [];

            for (const val of this.specialDatesValues)
            {
                datesOut.push({
                    value: `+${val}h`,
                    translatorValue: val,
                    text: 'PLUS_HOURS_FILTER',
                });
            }

            return datesOut;
        },
    },
};
</script>
